import { Flex, Text, useColorModeValue } from "@chakra-ui/react";
import CardHeader from "components/Card/CardHeader";
import { useTranslation } from "react-i18next";

function PermitteesDocumentsListPageCardHeader({ permitteeData }) {
  const textColor = useColorModeValue("gray.700", "white");
  const { t } = useTranslation();

  const tipo = permitteeData?.location?.description;
  const nome = permitteeData?.proprietario?.nome;
  const logradouro = permitteeData?.location?.logradouro;
  const numero = permitteeData?.numero;

  return (
    <CardHeader px="22px" mb="24px">
      <Flex gap="1" direction="column">
        {tipo && (
          <Text color={textColor} fontSize="sm">
            <strong>{t("permittees.fields.type")}:</strong> {tipo}
          </Text>
        )}
        {nome && (
          <Text color={textColor} fontSize="sm">
            <strong>{t("permittees.fields.owner")}:</strong> {nome}
          </Text>
        )}
        {logradouro && numero && (
          <Text color={textColor} fontSize="sm">
            <strong>{t("permittees.fields.stand")}:</strong> {logradouro + " - " + numero}
          </Text>
        )}
      </Flex>
    </CardHeader>
  );
}

export default PermitteesDocumentsListPageCardHeader;
